import React from 'react';
import { useNavigate } from "react-router-dom"
import LogoHpa from './images/logo.png';
import './pageaccueil.css';

const Acceuil = ({ socket }) => {
  const navigate = useNavigate()

  const modules = [
    { id: 'labo', label: 'Laboratoire', icon: '🔬', path: '/MgLabo', color: '#28a745' },
    { id: 'stock', label: 'Stock', icon: '📦', path: '/MgStock', color: '#4CAF50' },
    
    
    
    
    
    { id: 'caisse', label: 'Echantillons', icon: '🧪', path: '/MgCaisse', color: '#fd7e14' },
    { id: 'tasks', label: 'Tasks', icon: '📋', path: '/MgTasks', color: '#20c997' },
    { id: 'admin', label: 'Administration', icon: '⚙️', path: '/AdminPanel', color: '#6c757d' },
  ]

  return (
    <div className="geslab-page">
      {/* Top Info Bar */}
      <div className="geslab-topbar">
        <div className="geslab-topbar-left">
          <span className="topbar-item">📞 +235 66236614</span>
          <span className="topbar-item">✉️ hpa@amdjarass.city</span>
          <span className="topbar-item">🕐 Open 24/7</span>
        </div>
        <div className="geslab-topbar-right">
          <a href="/" className="topbar-link">🏠 Retour au site</a>
        </div>
      </div>

      {/* Navbar */}
      <nav className="geslab-navbar">
        <div className="geslab-navbar-brand">
          <img src={LogoHpa} alt="LNE" className="geslab-navbar-logo" />
          <div className="geslab-navbar-text">
            <h1 className="geslab-navbar-title">LNE - Ndjamena</h1>
            <span className="geslab-navbar-subtitle">Gestion des Laboratoires</span>
          </div>
        </div>
        <div className="geslab-navbar-menu">
          <span className="geslab-navitem active">Modules</span>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="geslab-hero">
        <div className="geslab-hero-content">
          <h2 className="geslab-hero-title">Votre Laboratoire, Notre Excellence</h2>
          <p className="geslab-hero-subtitle">
            Plateforme de gestion de laboratoire intégrée — Sélectionnez un module pour commencer
          </p>

          <div className="geslab-modules-grid">
            {modules.map((mod) => (
              <button
                key={mod.id}
                className="geslab-module-card"
                type="button"
                onClick={() => navigate(mod.path)}
                style={{ '--module-color': mod.color }}
              >
                <span className="module-card-icon">{mod.icon}</span>
                <span className="module-card-label">{mod.label}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Footer / Status */}
      <footer className="geslab-footer">
        <div className="geslab-footer-inner">
          <p className="geslab-footer-text">
            © {new Date().getFullYear()} Clinique Spécialisée la Référence — GesLAB
          </p>
          <div className={`geslab-status ${socket?.connected ? 'connected' : 'disconnected'}`}>
            <span className="status-dot" />
            <span className="status-text">
              {socket?.connected ? 'Serveur connecté' : 'Serveur déconnecté'}
            </span>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Acceuil
